import { Controller } from "@hotwired/stimulus";
import { toggleVisibility } from "../utils/stimulus_form_helper";

// Connects to data-controller="cancellation-request"
export default class extends Controller {
  static targets = ["refundAccountInput", "useSavedDetailsInput", "saveAgentBankDetailsInput", "bankDetailsPanel", "saveToAgentOrganisation", "savedBankDetailsPanel"];

  connect() {
    this.updateBankDetailsPanel();
  }

  // Handle form attribute updates on submit
  updateFormAttr() {
    const refundAccount = this._selectedRefundAccount();

    if (refundAccount === 'student') {
      if (this.hasUseSavedDetailsInputTarget) {
        this.useSavedDetailsInputTarget.value = '0';
      }
      if (this.hasSaveAgentBankDetailsInputTarget) {
        this.saveAgentBankDetailsInputTarget.value = '0';
      }
    }
  }

  // Update bank details panel data attributes based on selections
  updateBankDetailsPanel() {
    const refundAccount = this._selectedRefundAccount();
    const useSavedDetails = this._useSavedBankDetails();

    if (!this.hasBankDetailsPanelTarget) return;

    // If there are no refund account radio buttons, always show the bank details panel
    const hasRefundAccountOptions = this.hasRefundAccountInputTarget;

    const shouldShowSaveToAgentOrganisation = refundAccount === 'agent' && !useSavedDetails;
    if (this.hasSaveToAgentOrganisationTarget) {
      toggleVisibility(this.saveToAgentOrganisationTarget, shouldShowSaveToAgentOrganisation);
    }

    const shouldShowBankDetailsPanel = !hasRefundAccountOptions || shouldShowSaveToAgentOrganisation || (refundAccount === 'student');
    toggleVisibility(this.bankDetailsPanelTarget, shouldShowBankDetailsPanel);

    const shouldShowSavedBankDetailsPanel = refundAccount === 'agent' && useSavedDetails;
    if (this.hasSavedBankDetailsPanelTarget) {
      toggleVisibility(this.savedBankDetailsPanelTarget, shouldShowSavedBankDetailsPanel);
    }

    // Update data-attribute's value based on different situations
    if (refundAccount === 'agent') {
      if (useSavedDetails) {
        this.bankDetailsPanelTarget.setAttribute("data-should-not-submit", "true");
      } else {
        this.bankDetailsPanelTarget.setAttribute("data-should-not-submit", "false");
      }
    } else if (refundAccount === 'student') {
      this.bankDetailsPanelTarget.setAttribute("data-should-not-submit", "false");
    }
  }

  _selectedRefundAccount() {
    const checkedInput = this.refundAccountInputTargets.find(input => input.checked);
    return checkedInput ? checkedInput.value : null;
  }

  _useSavedBankDetails() {
    return this.hasUseSavedDetailsInputTarget && this.useSavedDetailsInputTarget.checked;
  }
}
